<template>
  <div class="no-polls-container">
    <div>{{ $t('POLLS.NO_ACTIVE_POLLS') }}</div>
  </div>
</template>

<script>
export default {
  name: 'no-active-polls',
  components: {}
};
</script>

<style lang="scss" scoped>
.no-polls-container {
  text-align: center;
}
.loader {
  display: inline-block;
  height: 200px;
  width: 200px;
}
.message-info {
  font-size: 20px;
  margin-bottom: 20px;
}
</style>
